import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IOnChangeServiceRequestCategories } from "../../../Orchestrator/Types/Interface/ActionParams/ServiceRequestActionParams";
import { ISelectedCategoryAndSubCategory, ISubServiceRequestCategory } from "../../../Orchestrator/Types/Interface/IServiceRequest";

class OnChangeServiceRequestCategories extends BaseAction<IDefaultActionResult, IOnChangeServiceRequestCategories> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }

        try {
            const { selectedCategoryAndSubCategory, type, value, serviceCategories } = this.params!
            let oldCategory: ISelectedCategoryAndSubCategory = {
                ...selectedCategoryAndSubCategory,
                [type]: value || null,
            };

            if (type === "category") {
                //Set sub category base on category
                const subCategoryList = (
                    serviceCategories.find((d) => d.categoryName === value)
                        ?.subCategories || []
                ).map((d: ISubServiceRequestCategory) => {
                    return { name: d.name, value: d.name };
                });

                updateRecoilState("subServiceCategoriesAtom", subCategoryList);

                // //By default, 1st option of the Subcategory will get selected.
                // if (subCategoryList.length > 0) {
                //     oldCategory = {
                //         ...oldCategory,
                //         subCategory: subCategoryList[0].value,
                //     };
                // }

                //Default sub category selected when category == "OTHERS" is selected - 1st option of the Subcategory will get selected in this case.
                if (oldCategory?.category == "OTHERS" && value == "OTHERS" && subCategoryList?.length > 0) {
                    oldCategory = {
                        ...oldCategory,
                        subCategory: subCategoryList[0]?.value,
                    };
                }
                else {
                    oldCategory = {
                        ...oldCategory,
                        subCategory: null,
                    };
                }
                actionResult.status = "success";
            }
            //OnChange of category and sub category we set submit button is disable by default
            updateRecoilState("submitRequestButtonDisabledAtom", true)
            updateRecoilState("serviceRequestFormDataAtom", [])

            updateRecoilState("selectedCategoryAndSubCategoryAtom", oldCategory);
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const onChangeServiceRequestCategories = new OnChangeServiceRequestCategories()